<template>
  <div class="c-question-view">
    <div class="c-question-view_container c-view-container">
      <div class="c-question-view_container__inner c-view-container__inner">
        <div class="c-question-view_content-col c-view-content-col">
          <h1 class="c-question-view__heading">{{ categoryName }}</h1>
          <div class="switches"></div>

          <div class="c-view-content-col__inner">
            <div v-html="question.Question"></div>

            <div class="c-question-view__toggle-area">
              <p class="c-question-view__toggle-text">Yes</p>
              <div
                class="c-question-view__toggle"
                :class="{
                  'c-question-view__toggle--empty': isAnswerEmpty,
                }"
              >
                <SwitchToggle
                  v-model="answer"
                  :showPotenitialSavings="showPotenitialSavings"
                  :isAnswerEmpty="isAnswerEmpty"
                />
              </div>
              <p class="c-question-view__toggle-text">No</p>
            </div>

            <div
              class="c-question-view__answer"
              :class="{
                'c-question-view__answer--empty': isAnswerEmpty,
              }"
            >
              <img
                class="c-question-view__answer-image"
                src="_resources/app/client/assets/images/answer-blue.svg"
                alt="answer icon"
                v-if="!showPotenitialSavings"
              />
              <img
                class="c-question-view__answer-image"
                src="_resources/app/client/assets/images/answer-green.svg"
                alt="answer icon"
                v-if="showPotenitialSavings"
              />

              <div class="c-question-view__answer-content-area">
                <div v-html="question.AnswerYes" v-if="answer == 'Yes'"></div>
                <div v-html="question.AnswerNo" v-if="answer == 'No'"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="c-question-view_animation-col c-view-animation-col">
          <div class="c-question-view_animation-wrapper">
            <div class="c-question-view_animation-circle"></div>
            <lottie-vue-player
              :src="animationsURL + question.AnimationURL"
              :player-controls="false"
              :loop="true"
              :autoplay="true"
            >
            </lottie-vue-player>
          </div>

          <div class="c-view_savings-area c-view_savings-area--mobile">
            <div
              class="c-view_savings-area-potential"
              v-if="showPotenitialSavings"
            >
              Potential Savings:
              <span class="c-view_savings-area-potential--bold"
                >+${{ getSavingsAmountWithMultiplier(question) }}</span
              >
            </div>

            <div class="c-view_savings-area-inner">
              <div class="c-view_savings-area-headings">
                <h5 class="c-view_savings-area-top">
                  <span>Total</span> Estimated
                </h5>
                <h4 class="c-view_savings-area-bottom">Annual Savings:</h4>
              </div>

              <div class="c-view_savings-area-total">
                <h3 class="c-view_savings-area-total-text">
                  ${{ getAnnualSavingsTotal }}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="c-view-controls__wrapper">
      <div class="c-view-controls">
        <div
          class="c-view-controls__inner c-view-controls__inner--justify-content"
        >
          <div class="c-buttons__wrapper">
            <button class="u-calc-button u-calc-button--prev" @click="prev">
              <span></span>
              <p>Previous</p>
            </button>
            <button class="u-calc-button" @click="next" v-if="canNavigateNext">
              <p>Next</p>
              <span></span>
            </button>
            <button
              class="u-calc-button u-calc-button--skip"
              @click="next"
              v-if="isAnswerEmpty"
            >
              <p>Skip</p>
              <span></span>
            </button>
          </div>

          <div class="c-view_savings-area c-view_savings-area--desktop">
            <div
              class="c-view_savings-area-potential"
              v-if="showPotenitialSavings"
            >
              Potential Savings:
              <span class="c-view_savings-area-potential--bold"
                >+${{ getSavingsAmountWithMultiplier(question) }}</span
              >
            </div>

            <div class="c-view_savings-area-inner">
              <div class="c-view_savings-area-headings">
                <h5 class="c-view_savings-area-top">
                  <span>Total</span> Estimated
                </h5>
                <h4 class="c-view_savings-area-bottom">Annual Savings:</h4>
              </div>

              <div class="c-view_savings-area-total">
                <h3 class="c-view_savings-area-total-text">
                  ${{ getAnnualSavingsTotal }}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import SwitchToggle from "../SwitchToggle.vue";

export default {
  props: {
    question: Object,
    categoryName: String,
  },
  created() {},
  components: {
    SwitchToggle,
  },
  mounted() {},
  watch: {
    currentStep: function (val) {
      //get the step name from an array of all steps (which includes all question QuestionSummaryText titles)
      this.currentStepName = this.allSteps.at(val);
    },
  },
  methods: {
    next() {
      this.$store.dispatch("updateCurrentStepByDirection", "next");

      let questionSelection = "";
      if (this.isAnswerEmpty) {
        questionSelection = "Skip";
      } else {
        questionSelection = this.answer;
      }

      console.log(
        "gtag answer value: " +
          this.question.QuestionSummaryText +
          " = " +
          questionSelection
      );

      this.$gtag.event("Answer", {
        event_category: "Questions",
        event_label: this.question.QuestionSummaryText + questionSelection,
      });
    },
    prev() {
      this.$store.dispatch("updateCurrentStepByDirection", "prev");
    },
  },
  computed: {
    ...mapFields([
      "config.baseUrl",
      "config.currentStep",
      "viewContent.Categories",
      "config.currentStepName",
    ]),
    ...mapGetters([
      "getQuestionAnswerById",
      "getAnnualSavingsTotal",
      "getSavingsAmountWithMultiplier",
      "getSlidesCount",
    ]),
    canNavigateNext() {
      return !this.isAnswerEmpty;
    },
    showPotenitialSavings() {
      let questionAnswer = this.getQuestionAnswerById(this.question.Id);
      if (questionAnswer) {
        //if the answer selected has savings then show the potential savings message
        return (
          questionAnswer.SavingsAssociatedWith == questionAnswer.selectedValue
        );
      }
      return false;
    },
    isAnswerEmpty() {
      return this.answer == "" ? true : false;
    },
    answer: {
      get() {
        let questionAnswer = this.getQuestionAnswerById(this.question.Id);
        if (questionAnswer == undefined) {
          return "";
        } else {
          return questionAnswer.selectedValue;
        }
      },
      set(value) {
        this.$store.commit("updateQuestionAnswer", {
          ...this.question,
          selectedValue: value,
        });
      },
    },
    /**
     * Returns animation url
     *
     * @return string
     * **/
    animationsURL() {
      return this.baseUrl;
    },
    allSteps() {
      let steps = ["Your Home"];
      this.Categories.forEach((category) => {
        if (category.Questions.length > 0) {
          category.Questions.forEach((question) => {
            steps.push(question.QuestionSummaryText);
          });
        }
      });
      steps.push("Results");
      return steps;
    },
  },
};
</script>
<style lang="scss">
.c-question-view {
}

.c-question-view__heading {
  font-family: "Nunito" !important;
  font-weight: 800 !important;
  font-size: 48px !important;
  line-height: 54px !important;
  margin: 0 !important;
  color: #ffffff;
  margin-bottom: 24px;

  @media (max-width: 755px) {
    font-size: 32px !important;
    line-height: 36px !important;
    margin-bottom: 12px;
  }
}

.c-question-view_content-col {
  width: 50%;
}

.c-question-view__toggle-area {
  display: flex;
  margin-top: 24px;
  max-height: 46px;

  p {
    text-transform: uppercase;
    font-family: "Nunito" !important;
    font-weight: 800 !important;
    font-size: 18px !important;
    line-height: 24px !important;
  }
}

.c-question-view__toggle {
  position: relative;
  display: inline-block;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin: 0 14px;

  input {
    display: none;
  }

  label {
    display: inline-block;
    vertical-align: center;
    font-size: 12px;
    font-weight: 700;
    line-height: 1em;
    color: #e4e4e4;
    cursor: pointer;
    transition: color 0.2s ease-in-out;
  }

  .c-toggle-label_yes {
    padding: 18px 32px 18px 32px;
  }

  .c-toggle-label_no {
    padding: 18px 32px 18px 32px;
  }

  .c-toggle_yes {
    position: absolute;
    height: 100%;
    width: 50%;
    left: 0;
    top: 0;
  }

  .c-toggle_no {
    position: absolute;
    height: 100%;
    width: 50%;
    right: 0;
    top: 0;
  }

  .label + .label {
    padding-right: 0.75em;
    padding-left: 0;
  }

  span {
    position: relative;
    z-index: 2;
    display: inline-block;
    min-width: 1.5em;
    opacity: 1;
    pointer-events: none;
    transition: opacity 0.2s ease-in-out;
  }

  .c-toggle_no:checked ~ .c-toggle-label_yes span,
  .c-toggle_yes:checked ~ .c-toggle-label_no span {
    opacity: 0;
  }

  label:before {
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: #ffffff;
    border-radius: 2.5em;
    border: 2px solid #000000;
    transition: background 0.2s ease-in-out;
  }

  .c-toggle_yes:checked ~ label:before {
    background: #ffffff;
  }

  .c-toggle-label_no:after {
    content: "";
    position: absolute;
    z-index: 2;
    top: 0.5em;
    bottom: 0.5em;
    left: calc(100% - 3.5em);
    width: 3em;
    border-radius: 3em;
    pointer-events: none;
    transition: left 0.2s ease-in-out, background 0.2s ease-in-out;
  }

  .c-toggle_yes:checked ~ .c-toggle-label_no:after {
    left: 0.5em;
  }
  .c-toggle_no:checked ~ .c-toggle-label_yes:before,
  .c-toggle_yes:checked ~ .c-toggle-label_no:before {
    z-index: 1;
  }
  .c-toggle_yes:checked ~ .c-toggle-label_yes {
    color: #e4e4e4;
  }

  &--empty {
    .c-toggle-label_no:after {
      background: #a8a8a8;
    }

    .c-toggle-label_no:after {
      left: calc(50% - 1.5em);
    }
  }
}

.c-toggle-label {
  &:after {
    background: #2393ff;
  }

  &--savings {
    &:after {
      background: #04b776;
    }
  }
}

.c-question-view__answer {
  background-color: #ffffff;
  border-radius: 26px;
  padding: 13px 20px;
  display: flex;
  flex-direction: row;
  margin-top: 34px;
  align-items: flex-start;

  &--empty {
    display: none;
  }

  @media (max-width: 755px) {
    flex-direction: column;
    margin-right: 14px;
  }

  img {
    width: 45px;
    height: 45px;

    @media (max-width: 755px) {
      width: 35px;
      height: 35px;
    }
  }
}

.c-question-view__answer-image {
}

.c-question-view__answer-content-area {
  margin-left: 12px;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
